import { useEffect, useState } from 'react';

export function useGetIp(getIp: boolean = true) {
  const [ip, setIp] = useState<string | null>(null);

  useEffect(() => {
    if (!getIp) return;
    fetch('https://api.ipify.org?format=json')
      .then((res) => res.json())
      .then((data) => setIp(data.ip))
      .catch(() => setIp(null));
  }, [getIp]);

  return ip;
}
